"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_redux_1 = require("@nimles/react-redux");

var react_redux_2 = require("react-redux");

var FacetAutoComplete_1 = require("./FacetAutoComplete");

var react_web_components_1 = require("@nimles/react-web-components");

var compare = function compare(property, descending) {
  return function (a, b) {
    var aProperty = a[property];
    var bProperty = b[property];

    if (typeof aProperty === 'number' && typeof bProperty === 'number') {
      return aProperty - bProperty;
    }

    if (aProperty < bProperty) {
      return descending ? 1 : -1;
    }

    if (aProperty > bProperty) {
      return descending ? -1 : 1;
    }

    return 0;
  };
};

var sortBy = function sortBy(array, property, descending) {
  return array.sort(compare(property, descending));
};

var getFacets = function getFacets(facetName) {
  if (!facetName) {
    return;
  }

  return facetName.indexOf('<=>') === -1 ? facetName + ",count:1000" : facetName.split('<=>').map(function (f) {
    return f + ",count:1000";
  });
};

exports.ProductFacetSelector = function () {
  var dispatch = react_redux_2.useDispatch();
  var facets = ['FitsBrand', 'FitsModel', 'FitsStartYear<=>FitsEndYear', 'FitsAttribute1', 'FitsAttribute2'];

  var _a = react_1.useState([]),
      selectedFacets = _a[0],
      setSelectedFacets = _a[1];

  var _b = react_1.useState([]),
      availableFacetsArray = _b[0],
      setAvailableFacetsArray = _b[1];

  react_1.useEffect(function () {
    (function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var response, facetName, facetResult;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , dispatch(react_redux_1.searchAndLoadPublicProducts({
                facets: facets[0] + ",count:1000",
                take: 24
              }))];

            case 1:
              response = _a.sent();
              facetName = facets[0];
              facetResult = response.facets[facetName.replace(/^\w/, function (c) {
                return c.toLowerCase();
              })];
              setAvailableFacetsArray([facetResult]);
              return [2
              /*return*/
              ];
          }
        });
      });
    })();
  }, facets);

  var handleFacetSelect = function handleFacetSelect(value, index) {
    return __awaiter(void 0, void 0, void 0, function () {
      var facetName, alreadySelectedFacets, queryFacets, queryParameters, response, facetResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (index >= facets.length) {
              return [2
              /*return*/
              ];
            }

            if (!value) {
              setSelectedFacets(selectedFacets.splice(0, index));
              return [2
              /*return*/
              ];
            }

            facetName = facets[index + 1];
            alreadySelectedFacets = __spreadArrays(selectedFacets.splice(0, index), [value]);
            setSelectedFacets(alreadySelectedFacets);
            queryFacets = getFacets(facetName);
            queryParameters = {
              filter: alreadySelectedFacets.map(function (f, i) {
                return facets[i].indexOf('<=>') === -1 ? facets[i] + " eq '" + f + "'" : facets[i].split('<=>').map(function (p, idx) {
                  return idx === 0 ? p + " le " + f : "(" + p + " ge " + f + " or " + p + " eq 0)";
                }).join(' and ');
              }).join(' and '),
              take: 24
            };

            if (queryFacets) {
              queryParameters.facets = queryFacets;
            }

            return [4
            /*yield*/
            , dispatch(react_redux_1.searchAndLoadPublicProducts(queryParameters))];

          case 1:
            response = _a.sent();
            facetResult = getFacetResult(facetName, response);

            if (facetResult) {
              setAvailableFacetsArray(__spreadArrays(availableFacetsArray.splice(0, index + 1), [facetResult]));
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return react_1.default.createElement(react_web_components_1.Row, {
    wrap: true
  }, availableFacetsArray.slice(0, selectedFacets.length + 1).map(function (availableFacets, index) {
    return react_1.default.createElement(react_web_components_1.Column, {
      xs: 100
    }, react_1.default.createElement(FacetAutoComplete_1.FacetAutoComplete, {
      availableFacets: availableFacets,
      selectedFacet: selectedFacets[index],
      onSelect: function onSelect(value) {
        return handleFacetSelect(value, index);
      }
    }));
  }));
};

function range(start, end) {
  return new Array(end - start + 1).fill(undefined).map(function (_, i) {
    return i + start;
  });
}

var getFacetResult = function getFacetResult(facetName, response) {
  if (!response.facets) {
    return;
  }

  if (facetName.indexOf('<=>') > -1) {
    var facetResults = facetName.split('<=>').map(function (f) {
      return response.facets[f.replace(/^\w/, function (c) {
        return c.toLowerCase();
      })];
    });
    var startYear = sortBy(facetResults[0], 'value')[0].value;
    var endYear = facetResults[1].some(function (f) {
      return f.value === 0;
    }) ? 2020 : sortBy(facetResults[1], 'value', true)[0].value;
    return range(startYear, endYear).map(function (value) {
      return {
        value: value
      };
    });
  }

  return response.facets[facetName.replace(/^\w/, function (c) {
    return c.toLowerCase();
  })];
};